import { buildContactIdLookupHooks, buildPropertyIdLookupHooks } from 'bundles/crm/imports/helpers';

export const SALE = 'sale';
export const LEASE = 'lease';
export type CompType = typeof SALE | typeof LEASE | null;

const ownerHooks = buildContactIdLookupHooks(
  'Owner Contact ID',
  { idKey: 'ownerContactId', queryKey: 'ownerName' },
);

const tenantHooks = buildContactIdLookupHooks(
  'Tenant Contact ID',
  { idKey: 'tenantContactId', queryKey: 'tenantName' },
);

const buyerHooks = buildContactIdLookupHooks(
  'Buyer Contact ID',
  { idKey: 'buyerContactId', queryKey: 'buyerName' },
);

const sellerHooks = buildContactIdLookupHooks(
  'Seller Contact ID',
  { idKey: 'sellerContactId', queryKey: 'sellerName' },
);

// If this is required in Dromo but missing a mapping in an uploaded CSV, the user is forced to add
// the field via the import UI. However, fields added that way are not detectable programmatically.
// So, leave it unrequired in Dromo, but always add it here as a required field.
const propertyHooks = buildPropertyIdLookupHooks(
  'Property ID',
  { idKey: 'propertyId', queryKey: 'property' },
  { force: true },
);

const DROMO_PROPS = {
  [SALE]: {
    bulkRowHooks: [propertyHooks.bulkRowHook, buyerHooks.bulkRowHook, sellerHooks.bulkRowHook],
    dromoSchemaId: '2252ae4e-d832-4092-a8e3-45161f26096c',
    groupId: 'crm_sale_comps',
    importerOptions: {
      parser: 'Backoffice::Importer::Providers::Dromo::Parsers::SaleComps',
    },
    importerType: 'crm',
    stepRowHooks: [propertyHooks.stepHook, buyerHooks.stepHook, sellerHooks.stepHook],
  },
  [LEASE]: {
    bulkRowHooks: [propertyHooks.bulkRowHook, ownerHooks.bulkRowHook, tenantHooks.bulkRowHook],
    dromoSchemaId: '47b8a14a-d86b-4d91-9f56-b1a5ba9a20c4',
    groupId: 'crm_lease_comps',
    importerOptions: {
      parser: 'Backoffice::Importer::Providers::Dromo::Parsers::LeaseComps',
    },
    importerType: 'crm',
    stepRowHooks: [propertyHooks.stepHook, ownerHooks.stepHook, tenantHooks.stepHook],
  }
};

export function getDromoImporterConfig(compType: CompType) {
  if (compType) {
    return DROMO_PROPS[compType];
  }
}

export const compGroupIds = [
  DROMO_PROPS[SALE].groupId,
  DROMO_PROPS[LEASE].groupId,
];
